// EventBus channel used to ask TakeOverToolbar to open its take-over modal.
// Shared so the emitter and the listener can never drift apart.
export const OPEN_TAKE_OVER_MODAL_EVENT = 'open-take-over-modal'

export default {
  ROLE: {
    EDITOR: 'editor',
    VIEWER: 'viewer',
  },
  MAX_ONLINE_HEADS_DISPLAY: 3,
  MAX_ALLOWED_COLLABORATORS: 100,
}
